import { render, staticRenderFns } from "./BindCompany.vue?vue&type=template&id=2ca34ad9&scoped=true&"
import script from "./BindCompany.vue?vue&type=script&lang=js&"
export * from "./BindCompany.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/css.css?vue&type=style&index=0&id=2ca34ad9&prod&scoped=true&lang=css&"
import style1 from "./BindCompany.vue?vue&type=style&index=1&id=2ca34ad9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca34ad9",
  null
  
)

export default component.exports